import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import HomeLayout from "./layouts/HomeLayout";
import Profile from "./Pages/components/Profile";
import Register from "./Pages/components/Register";
import { Provider, useDispatch, useSelector } from "react-redux";
import PrivateRoute from "./components/PrivateRoute";
import store from "./store";
import TimeLogs from "./Pages/components/TimeLogs";
import OnboardingFlow from "./Pages/components/splash/OnboardingFlow";
import LoginModal from "./components/modals/loginModal";
import { autoLogin } from "./store/slices/userSlice";
import ResetPin from "./Components/modals/ResetPin";
var MainApp = function () {
    return (_jsx(Provider, { store: store, children: _jsx(BrowserRouter, { children: _jsx(HomeLayout, { children: _jsx(Routes, { children: _jsx(Route, { path: "/", element: _jsx(RouteComponent, {}) }) }) }) }) }));
};
var PublicContainer = function () {
    return (_jsxs("div", { className: "public-container", children: [_jsx("div", { style: { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "start", margin: "1rem" }, children: _jsxs("div", { children: [_jsx("h2", { style: { textAlign: "center", fontWeight: "bold" }, children: "Keep Track of Your Hours, Pay, and Headers \u2014 All in\u00A0One\u00A0Place." }), _jsxs("p", { style: { textAlign: "center", marginTop: "1rem", fontSize: "1.1rem" }, children: ["MyDockInfo makes it easy to track your hours, pay rates, ships worked on, and headers. Everything you need is right at\u00A0your\u00A0fingertips.", _jsx("br", {}), _jsx("strong", { children: "Register today and take control of your maritime career!" })] })] }) }), _jsx(TimeLogs, {})] }));
};
var RouteComponent = function () {
    var dispatch = useDispatch();
    dispatch(autoLogin());
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var location = useLocation();
    var hash = location.hash;
    var ComponentToRender;
    if (!isLoggedIn && hash !== "#/register" && hash !== "#/login" && hash !== "#/reset-pin") {
        ComponentToRender = _jsx(OnboardingFlow, {});
        return ComponentToRender;
    }
    switch (hash) {
        // case "#/home": //https://chaseit1416.local/#/home
        //     ComponentToRender = <Home />;
        //     break;
        // case "#/bb-pilots":
        //     ComponentToRender = <BbPilots />;
        //     break;
        // case "#/vessel-map":
        //     ComponentToRender = <VesselFinder />;
        //     break;
        case "#/login":
            ComponentToRender = _jsx(LoginModal, { loginUser: function () { }, closeModal: function () { }, openForgetPinModal: function () {
                    // forgetPinModalHandle(true)
                } });
            break;
        case "#/reset-pin":
            ComponentToRender = _jsx(ResetPin, {});
            break;
        // case "#/about": //https://chaseit1416.local/#/about
        //     ComponentToRender = <About />;
        //     break;
        case "#/profile": //https://chaseit1416.local/#/profile
            ComponentToRender = (_jsx(PrivateRoute, { children: _jsx(Profile, {}) }));
            break;
        case "#/register": //https://chaseit1416.local/#/register
            ComponentToRender = _jsx(Register, {});
            break;
        // case "#/schedule": //https://chaseit1416.local/#/schedule
        //     ComponentToRender = <Schedule />;
        //     break;
        // case "#/search": //https://chaseit1416.local/#/search
        //     ComponentToRender = <Search />;
        //     break;
        // case "#/social": //https://chaseit1416.local/#/social
        //     ComponentToRender = (
        //         <PrivateRoute>
        //             <Social />
        //         </PrivateRoute>
        //     );
        //     break;
        // case '#/time-logs': //https://chaseit1416.local/#/time-logs
        //     ComponentToRender = (
        //         <PrivateRoute>
        //             <TimeLogs />
        //         </PrivateRoute>
        //     );
        //     break;
        // case "#/create-post": //https://chaseit1416.local/#/social
        //     ComponentToRender = (
        //         <PrivateRoute>
        //             <CreatePost />
        //         </PrivateRoute>
        //     );
        //     break;
        default: //https://chaseit1416.local
            // ComponentToRender = <App />;
            ComponentToRender =
                (_jsx(PrivateRoute, { children: _jsx(TimeLogs, {}) }));
    }
    return ComponentToRender;
};
ReactDOM.createRoot(document.getElementById("app")).render(_jsx(React.StrictMode, { children: _jsx(MainApp, {}) }));
